import { Button, mergeClasses } from "@fluentui/react-components";
import { ArrowSort16Regular, DismissRegular } from "@fluentui/react-icons";
import { MouseEvent } from "react";
import { CC_HEADER_ACTIONS, useTableStyle } from "./style";

interface HeaderActionsProps {
	showSort: boolean;
	showRemove: boolean;
	sortTitle: string;
	hideColumnTitle: string;
	onRemove: () => void;
}

export const HeaderActions = (props: HeaderActionsProps) => {
	const { showSort, showRemove, sortTitle, hideColumnTitle, onRemove } = props;
	const classes = useTableStyle();

	if (!showSort && !showRemove) {
		return null;
	}

	return (
		<span className={mergeClasses(classes.headerActions, CC_HEADER_ACTIONS)}>
			{showSort && (
				<Button
					appearance="transparent"
					size="small"
					title={sortTitle}
					className={classes.affordanceButton}
					icon={<ArrowSort16Regular />}
				/>
			)}
			{showRemove && (
				<Button
					appearance="transparent"
					size="small"
					title={hideColumnTitle}
					className={classes.affordanceButton}
					icon={<DismissRegular />}
					onClick={(event: MouseEvent<HTMLButtonElement>) => {
						event.stopPropagation();
						// The clicked header disappears, and React reuses its DOM node for
						// the next column; drop focus so `:focus-within` cannot keep the
						// actions of that next column visible.
						event.currentTarget.blur();
						onRemove();
					}}
				/>
			)}
		</span>
	);
};
